import(/* webpackMode: "eager", webpackExports: ["RpgClient"] */ "/vercel/path0/app/generator/rpg/RpgClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
